export default {"src":"/_next/static/media/helthcare-icon.23b26675.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};